function createCookie(name, value) {
    document.cookie = name + "=" + value + "; max-age=31536000; path=/; Secure";
}

function checkCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

function createConsentCookie(requiredCookie, analyticsCookie) {
    const consent = {
        requiredCookie: requiredCookie,
        analyticsCookie: analyticsCookie,
    };

    const asString = JSON.stringify(consent);

    createCookie("cookieConsent", asString);
}

function changeCheckbox(id, state) {
    const checkbox = document.querySelector(id);

    checkbox.checked = !!state;
}

function getValueOfCheckbox(id) {
    const checkbox = document.querySelector(id);

    return checkbox.checked;
}

function toggleCookieConsentSettingsModal() {
    const cookieConsentSettingsModal = document.querySelector("#ccSettingsModal");

    const cookieConsent = checkCookie("cookieConsent");
    let parsed;
    try {
        // @ts-ignore
        parsed = JSON.parse(cookieConsent) || {};
    } catch {
        parsed = {};
    }

    let analyticsCookie;
    if (parsed.analyticsCookie === undefined) {
        analyticsCookie = true;
    } else {
        analyticsCookie = !!parsed.analyticsCookie;
    }

    changeCheckbox("#ccRequiredCheckbox", parsed.requiredCookie || true);
    changeCheckbox("#ccAnalyticsCheckbox", analyticsCookie);
    // @ts-ignore
    cookieConsentSettingsModal.classList.toggle("is-active");
}

function saveCookieConsentSettings() {
    const required = getValueOfCheckbox("#ccRequiredCheckbox");
    const analytics = getValueOfCheckbox("#ccAnalyticsCheckbox");

    createConsentCookie(required, analytics);
}

function hasRequiredConsent() {
    try {
        const cookieValue = checkCookie("cookieConsent");
        // @ts-ignore
        return JSON.parse(cookieValue).requiredCookie;
    } catch {
        return false;
    }
}

window.addEventListener("load", function () {
    const ccBox = document.querySelector(".cc-box ");
    const cookieConsentAcceptButton = document.querySelector("#ccAcceptButton");
    const cookieConsentDeclineButton = document.querySelector("#ccDeclineButton");

    if (!cookieConsentAcceptButton || !cookieConsentDeclineButton) {
        return;
    }

    cookieConsentAcceptButton.addEventListener("click", () => {
        if (!hasRequiredConsent()) {
            createConsentCookie(true, true);
        }

        // @ts-ignore
        ccBox.classList.remove("cc-is-required");
    });
    cookieConsentDeclineButton.addEventListener("click", () => {
        if (!hasRequiredConsent()) {
            createConsentCookie(true, false);
        }
        // @ts-ignore
        ccBox.classList.remove("cc-is-required");
    });

    const cookieConsentChangeSettingsLink = document.querySelector("#ccChangeSettings");
    // @ts-ignore
    cookieConsentChangeSettingsLink.addEventListener("click", () => {
        toggleCookieConsentSettingsModal();
        ccBox?.classList.remove("cc-is-required");
    });

    const cookieConsentSaveSettingsButton = document.querySelector("#ccSaveSettingsButton");
    // @ts-ignore
    cookieConsentSaveSettingsButton.addEventListener("click", () => {
        saveCookieConsentSettings();
        toggleCookieConsentSettingsModal();
    });

    const cookieConsentFooterChangeSettings = document.querySelector("#ccFooterChangeSettings");
    // @ts-ignore
    cookieConsentFooterChangeSettings.addEventListener("click", () => {
        toggleCookieConsentSettingsModal();
    });
});

export default {};
